export class DEVSTAT {
    Type: string = "DEVSTAT";
    SerialNumber: string;
    Status: number;
    DeviceId: string;
    Date: Date;
}